import React, { useState } from 'react'
import Ribbon from '../../../core/common/ribbon/ribbon'
import { svgIcons } from '../../../style/fonts/SvgIcons';
import { Col, Nav, Row, Tab } from "react-bootstrap";
import { Link } from 'react-router-dom';
import AllTasks from './GeneralTasks';
import MainTasksSidebar from './TasksSidebarMian/MainTasksSidebar';
import CompletedTasksMain from './AssignedTasks';
import ModalComponent from '../../../core/common/modal/ModalComponent';
import CustomSelect from '../../../core/common/selectPirority/SelectPirority';
import FilterModalTasks from './FilterModalTasks';
import AssignConfirmationModal from './AssignConfirmationModal';
import GeneralTasks from './GeneralTasks';
import FilterComponent from '../../../core/common/FilterComponent';


const TasksMain = () => {
    const [selectedId, setselectedId] = useState<any[]>([]);
    const [showfilterModal, setShowfilterModal] = useState(false);
    const [showConfirmationModal, setShowConfirmationModal] = useState(false);


    const [activityTogglePopup, setActivityTogglePopup] = useState(false);
    const [isEditing, setIsEditing] = useState(false);

    const handleAddMainTasks = () => {
        setActivityTogglePopup(true);
        setIsEditing(false);
    };
    const handleEditMainTasks = () => {
        setActivityTogglePopup(true);
        setIsEditing(true)
    };

    const closeSidebar = () => {
        setActivityTogglePopup(false);
    };
    const options1 = [
        { value: 'All Users', label: 'All Users' },
        { value: "Active Users", label: "Active Users" },
        { value: "Inactive Users", label: "Inactive Users" },
        { value: "Active Organization Admin", label: "Active Organization Admin" },
    ];
    const handlefiltermodel = () => {
        setShowfilterModal(true);
        const dropdownToggle = document.getElementById('dropdownMenuClickableInsise');
        if (dropdownToggle) {
            dropdownToggle.click();
        }
    }
    const handleShowConfirmModal = () => {
        setShowConfirmationModal(true);
    }
    const handleClose = () => {
        setShowfilterModal(false)
        setShowConfirmationModal(false);

    };
    const handlefilterManage = () => {
    };
    const items = [
        {
            tooltipLabel: "Edit",
            icon: svgIcons.updateIcon,
            onClick: handleEditMainTasks,
            disableButton: selectedId?.length > 1 || selectedId?.length === 0 || selectedId?.length === null || selectedId?.length === undefined,
            disableIcon: svgIcons.updateIcon
        },
        {
            tooltipLabel: "View Details",
            icon: svgIcons.eyeIcon,
            onClick: handleEditMainTasks,
            disableButton: selectedId?.length > 1 || selectedId?.length === 0 || selectedId?.length === null || selectedId?.length === undefined,
            disableIcon: svgIcons.eyeIcon
        },

        // { label: "Save", icon: svgIcons.SaveIcon },
        { tooltipLabel: "Refresh", icon: <i className="ti ti-refresh"></i>, }
    ];
    return (

        <>
            <FilterModalTasks show={showfilterModal} handleClose={handleClose} />
            <AssignConfirmationModal show={showConfirmationModal} handleClose={handleClose} />
            <MainTasksSidebar activityTogglePopup={activityTogglePopup} closeSidebar={closeSidebar} isEditing={isEditing} />
            <div className="page-wrapper">
                <div className="content">
                <h4 className='color-red mb-2'>All Tasks</h4>
                    <div className="row">
                        <div className="col-md-12">
                        <Ribbon
                        items={items}
                        buttonText="+ New Task"
                        buttonClass="add-popup ribbon-btn "
                        onClickbtn={handleAddMainTasks}
                    />
                            <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                                <Row>
                                    <Col sm={12}>
                                        <div className="card card-css">
                                            <div className="card-body p-2">
                                            
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <div>
                                                        <Nav variant="pills" className="flex">
                                                            <Nav.Item>
                                                                <Nav.Link eventKey="first">General </Nav.Link>
                                                            </Nav.Item>
                                                            <Nav.Item>
                                                                <Nav.Link eventKey="second">Assigned</Nav.Link>
                                                            </Nav.Item>
                                                        </Nav>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Col>
                                    <Col sm={12}>
                                        <Tab.Content>
                                            <Tab.Pane eventKey="first">
                                                <GeneralTasks setselectedId={setselectedId} handleShowConfirmModal={handleShowConfirmModal} handlefiltermodel={handlefiltermodel} />
                                            </Tab.Pane>
                                            <Tab.Pane eventKey="second">
                                                <CompletedTasksMain setselectedId={setselectedId} />
                                            </Tab.Pane>
                                        </Tab.Content>
                                    </Col>
                                </Row>
                            </Tab.Container>

                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default TasksMain